import { render, staticRenderFns } from "./Fenlei.vue?vue&type=template&id=74681616&"
import script from "./Fenlei.vue?vue&type=script&lang=js&"
export * from "./Fenlei.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports